import { getVoucherCode, getOnecomConfig } from "store/selectors";
import { getNormalizedCartItems } from "../../utils";

const addPaymentInfo = (paymentType) => (dispatch, getState) => {
  const state = getState();
  const coupon = getVoucherCode(state);
  const items = getNormalizedCartItems(state);
  const { currency } = getOnecomConfig(state) || {};
  window.GTM.pushAddPaymentInfo({ coupon, paymentType, items, currency });
};

export default addPaymentInfo;
